import { Alert, Button, Modal } from 'react-bootstrap';

// Dismissible notice popup — used instead of window.alert() for action failures.
export default function MessageModal({
  show,
  onHide,
  title = 'Notice',
  message,
  variant = 'danger'
}) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title as="h5">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message && <Alert variant={variant} className="mb-0">{message}</Alert>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>OK</Button>
      </Modal.Footer>
    </Modal>
  );
}
